import React from "react";

import FacturesView from "../../../Views/FacturesView";
import SynthesesTabContent from "./SynthesesTabContent";
import DepensesTabContent from "./DepensesTabContent";

const FacturesViewTabsContent = ({ activeTab }) => {
  switch (activeTab) {
    case "Synthèses":
      return <SynthesesTabContent activeTab={activeTab} />;
    case "Expenses":
      return <DepensesTabContent activeTab={activeTab} />;
    case "Invoices":
      return <FacturesView />;
    default:
      return <SynthesesTabContent />;
  }
};

export default FacturesViewTabsContent;
